import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faBuilding, faCalendar, faCheckDouble, faChevronDown, faChevronLeft, faChevronRight, faEnvelope, faHandshake, faInfo, faInfoCircle, faList, faPhotoVideo, faQuoteLeft, faSearch, faStar } from '@fortawesome/free-solid-svg-icons';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView } from 'angular-calendar';
import { DataService } from 'src/app/services/data.service';
import * as moment from 'moment';
import { Group } from 'backend/interfaces/group.interface';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SidenavActions, SideNavService } from 'src/app/admin/services/side-nav.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  albumList = []
  faNext = faChevronRight;
  faPrev = faChevronLeft;
  faDown = faChevronDown;
  faPhoto = faPhotoVideo;
  faShake = faHandshake;
  faEnvelope = faEnvelope;
  faInfo = faInfoCircle;
  faStar = faStar;
  faCalendar = faCalendar;
  faBuilding = faBuilding;
  faQuoteLeft = faQuoteLeft;
  faCheckList = faCheckDouble;
  CalendarView = CalendarView;
  categories = [];
  viewDate: Date = new Date();
  minTime = this.viewDate.getHours()-1;
  maxTime = this.viewDate.getHours()+3;
  categoryCount;
  userCount;
  ads;
  events: CalendarEvent[] = [
  ];

  searchResult: Group[];
  searchPhrase = '';
  searchCategoryForm: FormGroup;
  faSearch = faSearch
  constructor(private dataService: DataService, private router: Router, private fb: FormBuilder, private sidenavService: SideNavService) {
    setInterval(() => {
      this.viewDate = new Date();
    }, 6000);
  }

  ngOnInit(): void {
    this.searchCategoryForm = this.fb.group({
         searchPhrase: ['']
       })
    this.dataService.topGroups$.subscribe(async res => {
      this.categories = await res;
    })

    this.dataService.groupCount$.subscribe(res => {
      this.categoryCount = res;
    })
    // this.dataService.usercount$.subscribe(res => {
    //   this.userCount = res;
    // })
  }

  newAppointment(): void{
    this.router.navigateByUrl('appointment');
  }

  docuMerge(): void{
    this.router.navigateByUrl('pdf-worker');
  }

  goTo(route: string): void {
    if (route === 'login') {
      this.router.navigate(['auth', 'login'], { queryParams: { returnUrl: this.router.url } });
      return;
    }
    this.router.navigate(['', route]);
  }

  open(categoryId: Group){
    this.router.navigate(['category', categoryId])
  }

  search(){
    const phrase = this.searchCategoryForm.controls['searchPhrase'].value;
    if(phrase && phrase.trim() !== ''){
      this.router.navigate(['/categories'], { queryParams: { q: phrase.trim() } });
    }
  }

  openVideoDialog(){
    this.sidenavService.open(SidenavActions.ViewVideoTutorials);
  }

  clearSearch(){
    this.searchPhrase = '';
    this.searchResult = null;
    this.searchCategoryForm.controls['searchPhrase'].setValue('');
  }

}
